import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import FeaturesTableRow from './FeaturesTableRow';
import FeaturesTableCell from './FeaturesTableCell';
import { FeaturesContext } from './FeaturesProvider';
import { CenteredSpinner } from './FeatureStyledComponents';

const FeaturesLimitedTableRows = ({
  activeColumn,
  currentProduct,
  showTooltip = false
}) => {
  const {
    features,
    highlightedProducts,
    productLine
  } = useContext(FeaturesContext);
  const highestTier = highlightedProducts[highlightedProducts.length - 1];

  if (!features[productLine]) {
    return /*#__PURE__*/_jsx("tr", {
      children: /*#__PURE__*/_jsx("th", {
        children: /*#__PURE__*/_jsx(CenteredSpinner, {
          size: "medium"
        })
      })
    }, "loading");
  }

  const productLineFeatures = features[productLine];
  const filteredFeatures = productLineFeatures.filter(feature => {
    return (feature.shouldUseDefaultLimits[currentProduct] || feature.shortLimits[currentProduct]) && !feature.hideFromLang;
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: filteredFeatures.map(feature => {
      return /*#__PURE__*/_jsx(FeaturesTableRow, {
        feature: feature,
        showTooltip: showTooltip,
        highestTier: highestTier,
        children: highlightedProducts.map((apiName, j) => {
          if (j === activeColumn) {
            return /*#__PURE__*/_jsx(FeaturesTableCell, {
              feature: feature,
              showTooltip: showTooltip,
              apiName: apiName,
              onlyShowCurrent: true
            }, j);
          }

          return null;
        })
      }, feature.featureId);
    })
  });
};

export default FeaturesLimitedTableRows;